import setExtent from './set-extent.action';

export default setExtent;
